var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E74C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9713 9.33203C12.3126 9.33203 9.33594 12.3227 9.33594 15.9987C9.33594 19.6747 12.3266 22.6654 16.0026 22.6654C19.6786 22.6654 22.6693 19.6747 22.6693 15.9987C22.6693 12.3227 19.6646 9.33203 15.9713 9.33203ZM16.6693 19.332H15.3359V17.9987H16.6693V19.332ZM16.6693 16.6654H15.3359V12.6654H16.6693V16.6654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorNotification);
export default __webpack_public_path__ + "static/media/error-notification.526b0f34fede7cfd44ccf3a7fa9dbb62.svg";
export { ForwardRef as ReactComponent };